import { getDisabledTextColor, getDisabledBackgroundColor, getTextColor } from '../../theme/defaultThemeOperators';
export const getFileAttachmentProcessingTextColor = getDisabledTextColor;
export const getFileAttachmentProcessingBackgroundColor = getDisabledBackgroundColor;
export const getFileAttachmentTextColor = getTextColor;
export const getFileAttachmentBackgroundColor = () => '#f5f8fa';
export const getFileAttachmentBorderColor = () => '#eaf0f6';